<template>
  <div id="confirm-paper">
    <div class="confirm">
      <dl>
        <dt>■メールアドレス</dt>
        <dd>{{order.email}}</dd>

        <dt>■お名前</dt>
        <dd>{{order.name}}</dd>

        <dt>■郵便番号</dt>
        <dd>
          {{order.zip}}<br>
        </dd>

        <dt>■ご住所</dt>
        <dd>
          {{order.address}}<br>
          {{order.street}}<br>
        </dd>

        <dt>■電話番号</dt>
        <dd>{{order.tel}}</dd>

        <dt>■決済方法</dt>
        <dd v-if="order.payment_method==='credit'">クレジットカード決済</dd>
        <dd v-if="order.payment_method==='bank'">銀行振込</dd>

        <dt>■備考</dt>
        <dd>{{order.comment}}</dd>

        <dt>■ご注文内容</dt>
        <dd>
          <div class="preview_container" v-for="cart in stockCart" :key="cart.id">
            <div id="preview_front" style="position:relative; height: 90px; float:left;">
              <part v-for="part in cart.parts" :key="'front_part_'+part.id" :part="part" :reverse="0"></part>
              <letter v-for="letter in cart.letters" :key="'front_letter_'+letter.id" :letter="letter" :reverse="0"></letter>
            </div>
            <div id="preview_back" style="position:relative;  height: 90px; float:left;">
              <part v-for="part in cart.parts" :key="'back_part_'+part.id" :part="part" :reverse="1"></part>
              <letter v-for="letter in cart.letters" :key="'back_letter_'+letter.id"  :letter="letter" :reverse="1"></letter>
            </div>
            <div class="clearfix">
              ▪{{cart.category.name | stripTags}}
              <br>
              {{cart.figure.name | stripTags}}
              /
              {{cart.design.name | stripTags}}
              <div v-for="pack in cart.packs" :key="pack.id">
                {{pack.size_name}} {{ designPrice | currency }} x {{pack.value}}
                {{ designPrice * pack.value | currency }}.-(税抜) <br>
                <span v-show="pack.number">#{{pack.number}} {{pack.name | stripTags}}</span>
              </div>
            </div>
            <br>
            <div>
              ▪カラー
              <br>
              <div v-for="part in cart.parts" :key="part.id" class="column_3">
                <div>{{part.label}}</div>
                <div v-if="selected_part_color(part)">{{ selected_part_color(part).name }}</div>
                <div v-if="selected_part_color(part) && selected_part_color(part).price">
                  {{ selected_part_color(part).price | currency }}
                </div>
              </div>
            </div>
            <br>
            <div v-if="cart_letters.length">
              ▪文字
              <br>
              <div v-for="letter in cart_letters" :key="letter.id" class="column_3">
                <div v-if="letter.decoration">
                  <div >{{ letter.name }}</div>
                  <div v-if="letter.font">
                    {{ letter.font.name }}
                    <span v-if="selected_letter_color(letter)"> / {{ selected_letter_color(letter).name }}</span>
                  </div>
                  <div v-if="letter.decoration.price">
                    <span>{{ letter.decoration.price | currency }}</span>
                    <span v-if="letter.decoration.color.price">(+{{ letter.decoration.color.price | currency }})</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="price_table">
            <div class="subtotal">合計 {{ cartStockTotalPrice | currency }}.-</div>
            <div class="consumption">消費税(10%) {{ cartStockTotalTax | currency }}.-</div>
            <div class="total">総計 {{ cartStockTotalPrice + cartStockTotalTax | currency }}.-</div>
            <div class="annotation">
              ※送料が別途700円(税込)かかります。購入金額が20,000円(税抜)以上の場合送料は無料となります。<br>
              ※シミュレータ上の色は、画面の発色の特性上、実物に出来上がる色とは異なる場合ありますのでご了承願います。<br>
              ※商品の出来上がりまでの期間は１ヶ月〜１ヶ月半となっております。<br>
              ※注文後のキャンセルは出来ません。また、イメージと違った・サイズが合わない等でのクレーム・交換も受け付けられませんので、ご了承ください。
            </div>
          </div>
        </dd>
      </dl>
    </div>

    <slot></slot>

    <div class="footer">
      <div class="footer-container">
        <div><vk-button @click="$router.back()">戻る</vk-button></div>
        <div>
          <vk-button v-if="!usePayJP" @click="next">注文確定</vk-button>
          <div ref="payjpArea" class="payjp"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Part from '../preview/Part.vue'
  import Letter from '../preview/Letter.vue'
  import {mapGetters} from 'vuex'

  export default {
    name: 'confirm-paper',
    components: {Part, Letter},
    data(){
      return {
        usePayJP: false,
      }
    },
    mounted() {
      // 再読み込みでオーダー情報がない時は戻る
      if (!this.order.name) {
        this.$router.push({path: 'input'});
        return;
      }
      if (this.order.payment_method === 'credit') {
        this.usePayJP = true;
      }
      if (this.usePayJP) {
        this.appendPayJpScriptTag();
        window.onTokenCreated = this.onTokenCreated;
        window.onTokenFailed = this.onTokenFailed;
      }
    },
    beforeDestroy() {
      const payjpCheckoutIframeEl = document.getElementById('payjp-checkout-iframe');
      if (payjpCheckoutIframeEl) payjpCheckoutIframeEl.parentElement.remove();
      if (this.login) {
        this.$refs.payjpArea.removeChild(this.scriptEl);
      }
      window.PayjpCheckout = null;
      window.onTokenCreated = null;
      window.onTokenFailed = null;
    },
    methods: {
      next() {
        // pay.jpはonTokenCreatedで処理する
        if (this.order.payment_method === 'bank') {
          this.$router.push({name: 'orderDone'});
        }
      },
      selected_part_color(part){
        return part.designs_part.color;
      },
      selected_letter_color(letter){
        if (!letter.decoration){
          return;
        }
        return letter.decoration.color;
      },
      appendPayJpScriptTag() {
        const attrs = {
          'type': 'application/javascript',
          'data-key': process.env.VUE_APP_PAY_JP_PUBLIC_KEY,
          'id': 'payjp-script',
          'src': 'https://checkout.pay.jp/',
          'class': 'payjp-button',
          'data-partial': true, // 入力後にtokenを作成し、windowを閉じる
          'data-text': '支払い情報入力',
          'data-submit-text': '支払う',
          'data-lang': 'ja',
          'data-on-created': 'onTokenCreated',
          'data-on-failed': 'onTokenFailed',
          'data-name-placeholder': 'TEST TARO',
        };
        this.scriptEl = document.createElement('script');
        Object.keys(attrs).forEach(key => this.scriptEl.setAttribute(key, attrs[key]));
        this.$refs.payjpArea.appendChild(this.scriptEl);
      },
      async onTokenCreated() {
        const token = document.getElementsByName('payjp-token')[0].value;
        this.payJpToken = token;

        let price = this.cartStockTotalPrice + this.cartStockTotalTax;
        if (price < 20000) price += 700;  // 2万未満の場合送料700円をプラス
        const options = {
          token,
          selected: this.selected,
          price,
        };

        try {
          const payResponse = await window.axios.post('/orders/payment.json', options);

          // さらにオーダーIDを作る
          this.$store.commit('setLoading');
          const orderResponse = await window.axios.post('/orders/add_stock_cart.json', {
            json:
              {
                order: this.$store.state.order,
                stock_cart: this.$store.state.stock_cart,
              },
          });

          this.$store.commit('resetLoading');
          this.$store.commit('setCartNumber', orderResponse.data.order.number);
          this.$store.commit('resetCartStock');

          this.$router.push({path: 'done', query: { id: orderResponse.data.order.number }});
        } catch (e) {
          this.$store.commit('resetLoading');
          alert('システムエラー：クレジットカードの認証に失敗しました');
        }
      },
      onTokenFailed() {},
    },
    computed: {
      ...mapGetters([
        'cart',
        'stockCart',
        'order',
        'designPrice',
        'basePrice',
        'totalPrice',
        'cartStockTotalPrice',
      ]),
      preview_cart() {
        return this.$store.state.cart;
      },
      category_name(){
        if (!this.cart.category) return null;
        return this.cart.category.name;
      },
      figure_name(){
        if (!this.cart.figure) return null;
        return this.cart.figure.name;
      },
      design_name(){
        if (!this.cart.design) return null;
        return this.cart.design.name;
      },
      cart_letters() {
        return this.cart.letters.filter(letter => {
          if (!letter.decoration) return false;
          return letter.decoration.color_id !== null;
        });
      },
      cartStockTotalTax () {
        return Math.ceil(this.cartStockTotalPrice * 0.1);
      }
    },
    watch: {
      $route(to, from) {
        if (to.path !== from.path) {
          window.PayjpCheckout = null;
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

  .confirm {
    padding: 5px;
    padding-bottom: 4rem;
  }
  .footer {
    color: #fff;
    background-color: #151d66;
    position: fixed;
    width: 100%;
    bottom: 0;
    .footer-container {
      height: 36px;
      display: flex;
      padding: 5px;
      &>div {
        flex-grow: 1;
        margin: 0 4px;
        button {
          width: 100%;
        }
      }
      div.payjp {
        flex-grow: 1;
        margin: 0 4px;
        & /deep/ #payjp_checkout_box > input[type=button] {
          width: 100%;
          background-image: none;
          background-color: transparent;
          border: 1px solid #fff;
          &:hover {
            border-color: #b2b2b2;
          }
        }
      }
    }
  }


  dd{
    margin-bottom: 1rem;
  }
  .subtotal, .consumption, .total{
    text-align: right;
  }
  .annotation{
    font-size:small;
  }

  #preview_front {
    width: 100px;
  }

  #preview_back {
    width: 100px;
  }

  .price_table{
    clear:both;
  }

  .picture {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    width: 100px;
    height: 80px;
  }

  .column_3 > div:nth-child(1){
    float: left;
    width:30%;
  }
  .column_3 > div:nth-child(2){
    float: left;
    width:55%;
  }
  .column_3 > div:nth-child(3){
    float: left;
    width:15%;
    text-align: right;
  }
  .column_3:after{
    content: "";
    clear: both;
    height: 0;
    display: block;
    visibility: hidden;
  }
  .clearfix {
    clear: both;
  }
</style>
